import { Modal } from '@mui/material';
import ModalContainer from 'components/ModalContainer';
import clsx from 'clsx';
import styles from './ConsentModal.module.scss';
import CheckboxWithButton from './CheckboxWithButton';

const ConsentModal = ({
  isModelOpen,
  setIsOpen,
  handleClose,
  setIsAgree,
  isAgree,
  checkboxText,
  isShouldScroll,
  isScrolled,
  children,
  background,
  isFullScreenActive,
  setIsFullScreenActive,
  isFullScreen,
}) => (
  <Modal
    open={isModelOpen}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    onClose={() => handleClose(setIsOpen)}
    BackdropProps={{
      classes: {
        root: isFullScreenActive ? styles.backDrop : '',
      },
    }}
  >
    <ModalContainer
      background={background || 'rgba(255, 255, 255, 0.8)'}
      isShouldScroll={isShouldScroll}
      handleClose={() => handleClose(setIsOpen)}
      isConsentModal
      isFullScreen={isFullScreen}
      isFullScreenActive={isFullScreenActive}
      setIsFullScreenActive={setIsFullScreenActive}
    >
      <div
        className={clsx(
          styles.consentWrapper,
          isFullScreenActive ? styles.fullScreenContentWrapper : ''
        )}
      >
        {children}
        <CheckboxWithButton
          isAgree={isAgree}
          setIsAgree={setIsAgree}
          text={checkboxText}
          handleClose={handleClose}
          setIsOpen={setIsOpen}
          isShouldScroll={isShouldScroll}
          isScrolled={isScrolled}
        />
      </div>
    </ModalContainer>
  </Modal>
);

export default ConsentModal;
